const RequestMethod = {
  INIT: 'initialize',
  EXEC: 'execute',
};

const FunctionName = {
  INIT: 'init',
  IS_APD_READY: 'isAPDReady',
  PROCESS_APD_WALLET_SAVE: 'processAPDWalletSave',
  PROCESS_APD_REFUND: 'processAPDRefund',
  PROCESS_APD_AUTH: 'processAPDAuth',
  PROCESS_APD_PAYMENT: 'processAPDPayment',
  PROCESS_APD_CAPTURE: 'processAPDCapture',
  PROCESS_APD_VOID: 'processAPDVoid',
  MAGTEK_EXCELLA_GET_DEVICE_NAMES: 'getDeviceNames',
  MAGTEK_EXCELLA_SCAN_CHECK: 'scanCheck',
  MAGTEK_EXCELLA_GET_FILE_IMAGE: 'getImageFromFile',
  MAGTEK_EXCELLA_GET_DEVICE_IMAGE: 'getImageFromDevice'
};

const Processor = {
  MONERIS_EMV: 'apdmonerisemv',
  PAYMENTTECH_EMV: 'apdpaymenttechemv',
  EMV_ELAVON: 'apdemvelavon',
  PAX_EMV: 'apdpaxemv',
  THERMALDEVICE: 'thermaldevice',
  APDUPA: 'apdupa',
  MAGTEKEXCELLA: 'magtekexcellastx'
};

function getWebSocket(port) {
  return new WebSocket(`wss://wss.active.com:${port || '4444'}/websocket`);
}

const JSONResultForWebSocketResponse = { exception: 'exception', failed: 'failed', success: 'success' };

function handleWebSocketResponse(message) {
  let response = {};

  try {
    response = JSON.parse(message.data);
  } catch (err) {
    response.status = JSONResultForWebSocketResponse.exception;
    response.message = 'Parse response to json failed.';
  }

  return response;
}

function buildWebSocketRequest(method, organization, workstationId, externalIdentifier) {
  const request = {};

  request.method = method;
  request.organization = organization;
  request.workstationId = workstationId;
  request.externalIdentifier = externalIdentifier;
  request.parameter = [];

  return request;
}

function buildWebSocketRequestParameter(processor, method, parameters) {
  const requestParameter = {};

  requestParameter.processor = processor;
  requestParameter.method = method;
  requestParameter.parameters = parameters;

  return requestParameter;
}

function buildWebSocketRequestParameterWithJSON(processor, method, parameters, jsonParameter) {
  const requestParameter = {};

  requestParameter.processor = processor;
  requestParameter.method = method;
  requestParameter.parameters = parameters;
  requestParameter.jsonParameter = jsonParameter;

  return requestParameter;
}

function getWSRequest(requestMethod, functionName, parameters, processorName, identifier) {
  const request = buildWebSocketRequest(requestMethod, '', '', identifier);
  const requestParameters = buildWebSocketRequestParameter(processorName, functionName, parameters);
  request.parameter.push(requestParameters);
  return request;
}

function getWSRequestForJSON(requestMethod, functionName, parameters, jsonParameter, processorName, identifier) {
  const request = buildWebSocketRequest(requestMethod, '', '', identifier);
  const requestParameters = buildWebSocketRequestParameterWithJSON(processorName,
    functionName, parameters, JSON.stringify(jsonParameter));
  request.parameter.push(requestParameters);
  return request;
}

/*
* package sendWS function with promise
* @param {string} port: ws port
* @param {object} request: the request object which sent to WS server.
* @param {function} onError: will be called if failed to call getWebSocket
*/
function sendWSPromise(request) {
  return new Promise((resolve, reject) => {
    let globalWebSocket;
    let manualClose = false;
    try {
      globalWebSocket = getWebSocket('4444');
    } catch (exception) {
      reject(exception);
    }

    globalWebSocket.onopen = () => {
      globalWebSocket.send(JSON.stringify(request));
    };

    globalWebSocket.onmessage = (evt) => {
      const response = handleWebSocketResponse(evt);
      manualClose = true;
      globalWebSocket.close();
      if (response.status === JSONResultForWebSocketResponse.success) {
        resolve(response);
      } else {
        reject(new Error('FAIL'));
      }
    };

    globalWebSocket.onerror = (err) => {
      manualClose = true;
      globalWebSocket.close();
      reject(JSON.stringify(err));
    };

    globalWebSocket.onclose = () => {
      if (!manualClose) {
        reject(new Error('closed by accident.')); // just in case
      }
    };
  });
}

const WSS = {
  RequestMethod,
  FunctionName,
  Processor,
  getWSRequest,
  getWSRequestForJSON,
  sendWSPromise,
};

export default WSS;
